import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function AcademyLauncher({ page, onHelp, onTour }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const hasTour = Boolean(page?.steps?.length);

  return (
    <div className={`academyLauncher ${open ? "is-open" : ""}`}>
      {open && (
        <div className="academyLauncherMenu" role="menu">
          <div className="academyLauncherMenuHeader">
            <span>{page?.title ? t(page.title) : ""}</span>
            <small>{t("academy_current_page_help")}</small>
          </div>

          <button type="button" onClick={onHelp} role="menuitem">
            <span className="academyLauncherMenuIcon">?</span>
            <span>
              <strong>{t("academy_open_guide")}</strong>
              <small>{t("academy_features_and_answers")}</small>
            </span>
          </button>

          <button type="button" onClick={onTour} role="menuitem">
            <span className="academyLauncherMenuIcon">▶</span>
            <span>
              <strong>
                {hasTour
                  ? t("academy_start_tutorial")
                  : t("academy_open_lesson")}
              </strong>
              <small>
                {hasTour
                  ? t("academy_step_by_step_highlight")
                  : t("academy_page_instructions")}
              </small>
            </span>
          </button>
        </div>
      )}

      <button
        type="button"
        className="academyLauncherButton"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        title={t("academy_name")}
      >
        <span aria-hidden="true">{open ? "×" : "?"}</span>
      </button>
    </div>
  );
}
